import React from 'react'
import './BusinessSupport.css'

const BusinessSupport = () => {
    return (
        <section className="support-contect-section">
            <div className="container">
                <div className="support-main-content">
                    <div className="support-info">
                        <h1 className="invisible-heading">HELP DESK</h1>
                        <h2 className="visible-heading"><span className="heighlight">SUPPORT CENTRE</span></h2>
                        <div className="separetor-ul"></div>
                        <p className="description">Do you need extra assistance? Complete the form and one of our support representatives will be in touch soon to help.</p>
                    </div>
                    <div className="support-contact-form">
                        <div className="form-basic-item">
                            <label className="requre">First Name</label>
                            <input type="text" className="f-name" />
                        </div>
                        <div className="form-basic-item">
                            <label className="requre">Last Name</label>
                            <input type="text" className="l-name" />
                        </div>
                        <div className="form-basic-item">
                            <label>Phone</label>
                            <input type="text" className="phone" />
                        </div>
                        <div className="form-basic-item">
                            <label className="requre">Email</label>
                            <input type="text" className="email" />
                        </div>
                        <div className="form-basic-item">
                            <label>Business Name</label>
                            <input type="text" className="b-name" />
                        </div>
                        <div className="form-basic-item">
                            <label className="requre">User Type</label>
                            <select className="u-type">
                                <option value="Not Currently a Member ">Not Currently a Member </option>
                                <option value="Elite Business User">Elite Business User</option>
                                <option value="Elite Party Member">Elite Party Member</option>
                            </select>
                        </div>
                        <div className="form-basic-item form-sp-item">
                            <label>Business Name</label>
                            <textarea type="text" rows="4" className="b-name" />
                        </div>
                        <div className="form-basic-item">
                            <button>SEND</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BusinessSupport
